module.exports = __webpack_public_path__ + "img/invest_card_icon.08792fc9.svg";